import { render, staticRenderFns } from "./CreateEmployer.vue?vue&type=template&id=5a5997d8&"
import script from "./CreateEmployer.vue?vue&type=script&lang=js&"
export * from "./CreateEmployer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports